import { z } from "zod";

const formSchema = z.object({
  discount_type: z.string(),
  description: z.string().optional().nullable(),
  payment_type: z.string(),
  amount: z.union([z.number(), z.string()]),
  start_date: z.preprocess((arg) => {
    if (typeof arg === "string" || arg instanceof Date) {
      return new Date(arg);
    }
    return arg;
  }, z.date()),
  end_date: z.preprocess((arg) => {
    if (typeof arg === "string" || arg instanceof Date) {
      return new Date(arg);
    }
    return arg;
  }, z.date().optional().nullable()),
  periods: z.array(
    z.object({
      amount: z.string(),
      date: z.string(),
    })
  ).optional().nullable(),
}).refine((data) => {
  if (data.payment_type === 'Monthly Recurring') { 
    return data.end_date !== null && data.end_date !== undefined;
  }
  return true;
}, {
  message: "End date is required when payment type is 'Monthly Recurring'",
  path: ["end_date"],
});

export default formSchema;